import React from 'react';

export interface CFSection {
  title: string;
  /** A ReactElement value (a CommitteeLink) renders as-is; everything else as text. */
  fields: Array<{ label: string; value: string | number | boolean | React.ReactElement | undefined | null }>;
}

/**
 * The two-column definition list that CFRecordModal and CFTransactionModal both
 * render. Identical in both, down to the empty-value rule: a field with no value
 * is omitted rather than shown as a blank row, because a filed record has dozens
 * of optional columns and printing them all buries the handful that are set.
 */
const CFRecordSections: React.FC<{ sections: CFSection[] }> = ({ sections }) => (
  <div className="grid gap-6 md:grid-cols-2">
    {sections.map((section) => (
      <div key={section.title}>
        <div className="mb-3 text-xs font-semibold uppercase tracking-wider text-text-secondary dark:text-text-dark-secondary">
          {section.title}
        </div>
        <dl className="space-y-2">
          {section.fields.map((f) => {
            if (f.value === undefined || f.value === null || f.value === '') return null;
            return (
              <div key={f.label}>
                <dt className="text-xs font-medium text-text-tertiary dark:text-text-dark-tertiary">
                  {f.label}
                </dt>
                <dd className="mt-0.5 text-sm text-text-primary dark:text-text-dark-primary">
                  {React.isValidElement(f.value) ? f.value : String(f.value)}
                </dd>
              </div>
            );
          })}
        </dl>
      </div>
    ))}
  </div>
);

export default CFRecordSections;
